import { Box, Center } from '@chakra-ui/react'
import LPHero from '@src/components/sco/LayoutBlocks/LPHero'
import { UserSearchBuilder } from '@src/components/sco/Matching/UserSearchBuilder'
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar'

import { useSearchParams } from 'next/navigation'
import React from 'react'

export default function Page() {
  const params = useSearchParams()

  return (
    <>
      <ScoSiteNavBar />
      <Center minHeight={'80vh'} paddingX={'1em'} paddingY={['1em', '1em', '2em', '3em']}>
        <LPHero
          description={'Find Startup-Obsessed Co-Founders, Experts, Peers, and Talent'}
          title={'Build your Startup Dream Team'}
        >
          <Box maxWidth={'container.xl'} paddingY={[4, 4, 0]} width={'full'}>
            <UserSearchBuilder emailCaptureMethod={'inline'} />
          </Box>
        </LPHero>
      </Center>
    </>
  )
}
